import { defineAction } from '~/prix'
import { z } from 'zod'
import citizenTrainedDeleteAction from './citizenTrainedDelete.action.json' with { type: 'json' }
import { trainingPerformedObject } from '../citizenTrainedObject'
import { dateOrIsoString } from '~/prix/types/date'

const citizenTrainedDeleteDefinition = defineAction({
  ...citizenTrainedDeleteAction,

  input: z.object({ id: trainingPerformedObject.shape.id }),
  output: z.object({}),
})

export default citizenTrainedDeleteDefinition
